module.exports = __webpack_public_path__ + "img/facct-logo.545b8479.jpg";